export var UserActions = /*#__PURE__*/function (UserActions) {
  UserActions["JOIN"] = "JOIN";
  UserActions["RESUBSCRIBE"] = "RESUBSCRIBE";
  UserActions["RESUME"] = "RESUME";
  UserActions["REVOKE_PENDING_CANCEL"] = "REVOKE_PENDING_CANCEL";
  UserActions["REVOKE_PENDING_PAUSE"] = "REVOKE_PENDING_PAUSE";
  UserActions["UPGRADE"] = "UPGRADE";
  UserActions["DOWNGRADE"] = "DOWNGRADE";
  return UserActions;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/constants/UserActions.js
// module id = 4053
// module chunks = 11